import { useEffect, useMemo } from 'react'
import { usePickupWarehouses } from '../hooks/usePickupWarehouses'

function FulfillmentSelector({ shippingSettings, value, onChange, disabled = false, availableMethods: availableMethodsProp, forcedMethod }) {
  const fulfillment = shippingSettings?.fulfillment || {}
  const homeDeliveryEnabled = fulfillment.homeDeliveryEnabled !== false
  const pickupEnabled = fulfillment.pickupEnabled === true
  const pickupWarehouseIds = Array.isArray(fulfillment.pickupWarehouseIds) ? fulfillment.pickupWarehouseIds : []

  const { warehouses, loading } = usePickupWarehouses(pickupEnabled ? pickupWarehouseIds : [])

  const availableMethods = useMemo(() => {
    const base = Array.isArray(availableMethodsProp) && availableMethodsProp.length
      ? availableMethodsProp
      : (() => {
        const out = []
        if (homeDeliveryEnabled) out.push('delivery')
        if (pickupEnabled) out.push('pickup')
        return out
      })()
    if (forcedMethod) return [forcedMethod]
    return base
  }, [availableMethodsProp, forcedMethod, homeDeliveryEnabled, pickupEnabled])

  useEffect(() => {
    if (!availableMethods.length) return
    if (forcedMethod) return
    const current = value?.method
    if (!current || !availableMethods.includes(current)) {
      onChange?.({ method: availableMethods[0], pickupWarehouseId: '' })
    }
  }, [availableMethods, forcedMethod, onChange, value?.method])

  if (!availableMethods.length) return null

  const method = forcedMethod || value?.method || availableMethods[0]

  return (
    <div className="w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-4">
      <div className="text-sm font-semibold text-text-dark dark:text-text-light mb-3">Entrega</div>

      {availableMethods.length > 1 ? (
        <div className="flex flex-col gap-2">
          {homeDeliveryEnabled && (
            <label className="flex items-center gap-2 text-sm text-text-dark dark:text-text-light">
              <input
                type="radio"
                name="fulfillmentMethod"
                value="delivery"
                checked={method === 'delivery'}
                onChange={() => onChange?.({ method: 'delivery', pickupWarehouseId: '' })}
                disabled={disabled}
              />
              Envío a domicilio
            </label>
          )}
          {pickupEnabled && (
            <label className="flex items-center gap-2 text-sm text-text-dark dark:text-text-light">
              <input
                type="radio"
                name="fulfillmentMethod"
                value="pickup"
                checked={method === 'pickup'}
                onChange={() => onChange?.({ method: 'pickup', pickupWarehouseId: value?.pickupWarehouseId || '' })}
                disabled={disabled}
              />
              Retiro por sucursal
            </label>
          )}
          {availableMethods.includes('negotiation') && (
            <label className="flex items-center gap-2 text-sm text-text-dark dark:text-text-light">
              <input
                type="radio"
                name="fulfillmentMethod"
                value="negotiation"
                checked={method === 'negotiation'}
                onChange={() => onChange?.({ method: 'negotiation', pickupWarehouseId: '' })}
                disabled={disabled}
              />
              Acordar con vendedor
            </label>
          )}
        </div>
      ) : (
        <div className="text-sm text-text-dark dark:text-text-light">
          {method === 'pickup' ? 'Retiro por sucursal' : method === 'negotiation' ? 'Acordar con vendedor' : 'Envío a domicilio'}
        </div>
      )}

      {method === 'pickup' && (
        <div className="mt-4">
          <div className="text-xs text-text-light mb-2">Elegí la sucursal para retirar</div>
          <select
            className="w-full rounded-lg border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-text-dark dark:text-text-light text-sm p-3"
            value={value?.pickupWarehouseId || ''}
            onChange={(e) => onChange?.({ method: 'pickup', pickupWarehouseId: e.target.value })}
            disabled={disabled || loading}
          >
            <option value="">Seleccionar sucursal</option>
            {warehouses.map((w) => (
              <option key={w.id} value={w.id}>
                {w.name || 'Sucursal'}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
}

export default FulfillmentSelector
